import { render, staticRenderFns } from "./BroadcastDriversDialog.vue?vue&type=template&id=0527350e&scoped=true&"
import script from "./BroadcastDriversDialog.vue?vue&type=script&lang=js&"
export * from "./BroadcastDriversDialog.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastDriversDialog.vue?vue&type=style&index=0&id=0527350e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0527350e",
  null
  
)

/* custom blocks */
import block0 from "./BroadcastDriversDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports